// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
}

h6{
  font-size: 16px !important;
}

.css-1k726au-MuiTypography-root{
  font-size: 50px !important;
}
.css-by3vyz-MuiTypography-root{
  font-size: 50px !important;
}

/* h2{
  font-size: 34px !important;
} */

body {
  margin: 0;
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  margin-top: 50px;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* Custom styles for the thumbnails */
/* .image-gallery .image-gallery-thumbnail {
  border: 2px solid transparent;
  height: 200px;
  width: 150px;
  overflow: hidden;
  transition: border-color 0.3s ease, transform 0.3s ease;
} */

.image-gallery .image-gallery-thumbnail:hover {
  border-color: #ff7900;
}

.image-gallery .image-gallery-thumbnail.active {
  border-color: #e79f1b;
}
@media only screen and (max-width: 600px) {
  .main-image-slider {
    height: 300px !important;
  }
}

.react-calendar {
  width: 100%;
  max-width: 100%;
  background-color: white;
  border: none;
  border-radius: 8px;
  font-family: Arial, sans-serif;
  line-height: 1.125em;
  border: none !important;
}

.react-calendar__navigation {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.react-calendar__navigation button {
  color: #333;
  font-size: 16px;
  font-weight: bold;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
}

.react-calendar__navigation button:enabled:hover {
  background-color: #f0f0f0;
  border-radius: 4px;
}

.react-calendar__month-view__weekdays {
  font-weight: 600;
  text-align: center;
  color: #555;
  margin-bottom: 10px;
}

.react-calendar__tile {
  max-width: 100%;
  text-align: center;
  padding: 10px;
  border-radius: 50%;
  transition: background-color 0.3s, color 0.3s;
}

.react-calendar__tile--now {
  background: #ffefc0;
  border-radius: 50%;
}

.react-calendar__tile--active {
  background: #ff7900;
  color: white;
  border-radius: 50%;
}

.react-calendar__tile:enabled:hover {
  background: #ff7900;
  color: white;
  border-radius: 50%;
}

.react-calendar__tile--active:enabled:hover {
  background: #ff7900;
}

.react-calendar__month-view__days__day--weekend {
  color: #ff7900;
}

.highlight {
  background: #ff7900 !important;
  color: #fff !important;
}

.calendar-container {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  max-width: 400px;
  margin: 0 auto;
}

.calendar-header {
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
  color: #333;
}

.MuiBox-root.css-itff6b {
  position: sticky;
  top: 10px;
}

.css-1nhdi3b {
  height: 20px !important;
  width: 20px !important;
}
.css-6si1ej{
  width: 20px !important;
    height: 20px !important;
}
h2.MuiTypography-root.MuiTypography-h2.css-1who5ts-MuiTypography-root {
  font-size: 25px !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;;GAEG;;AAEH;EACE,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA,qCAAqC;AACrC;;;;;;GAMG;;AAEH;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,sBAAsB;IACpB,uBAAuB;AAC3B;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Inter\", sans-serif;\n  font-optical-sizing: auto;\n}\n\nh6{\n  font-size: 16px !important;\n}\n\n.css-1k726au-MuiTypography-root{\n  font-size: 50px !important;\n}\n.css-by3vyz-MuiTypography-root{\n  font-size: 50px !important;\n}\n\n/* h2{\n  font-size: 34px !important;\n} */\n\nbody {\n  margin: 0;\n  font-family: \"Inter\", sans-serif;\n  font-optical-sizing: auto;\n  margin-top: 50px;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* Custom styles for the thumbnails */\n/* .image-gallery .image-gallery-thumbnail {\n  border: 2px solid transparent;\n  height: 200px;\n  width: 150px;\n  overflow: hidden;\n  transition: border-color 0.3s ease, transform 0.3s ease;\n} */\n\n.image-gallery .image-gallery-thumbnail:hover {\n  border-color: #ff7900;\n}\n\n.image-gallery .image-gallery-thumbnail.active {\n  border-color: #e79f1b;\n}\n@media only screen and (max-width: 600px) {\n  .main-image-slider {\n    height: 300px !important;\n  }\n}\n\n.react-calendar {\n  width: 100%;\n  max-width: 100%;\n  background-color: white;\n  border: none;\n  border-radius: 8px;\n  font-family: Arial, sans-serif;\n  line-height: 1.125em;\n  border: none !important;\n}\n\n.react-calendar__navigation {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.react-calendar__navigation button {\n  color: #333;\n  font-size: 16px;\n  font-weight: bold;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.react-calendar__navigation button:enabled:hover {\n  background-color: #f0f0f0;\n  border-radius: 4px;\n}\n\n.react-calendar__month-view__weekdays {\n  font-weight: 600;\n  text-align: center;\n  color: #555;\n  margin-bottom: 10px;\n}\n\n.react-calendar__tile {\n  max-width: 100%;\n  text-align: center;\n  padding: 10px;\n  border-radius: 50%;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.react-calendar__tile--now {\n  background: #ffefc0;\n  border-radius: 50%;\n}\n\n.react-calendar__tile--active {\n  background: #ff7900;\n  color: white;\n  border-radius: 50%;\n}\n\n.react-calendar__tile:enabled:hover {\n  background: #ff7900;\n  color: white;\n  border-radius: 50%;\n}\n\n.react-calendar__tile--active:enabled:hover {\n  background: #ff7900;\n}\n\n.react-calendar__month-view__days__day--weekend {\n  color: #ff7900;\n}\n\n.highlight {\n  background: #ff7900 !important;\n  color: #fff !important;\n}\n\n.calendar-container {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 20px;\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.calendar-header {\n  font-weight: 600;\n  margin-bottom: 20px;\n  text-align: center;\n  color: #333;\n}\n\n.MuiBox-root.css-itff6b {\n  position: sticky;\n  top: 10px;\n}\n\n.css-1nhdi3b {\n  height: 20px !important;\n  width: 20px !important;\n}\n.css-6si1ej{\n  width: 20px !important;\n    height: 20px !important;\n}\nh2.MuiTypography-root.MuiTypography-h2.css-1who5ts-MuiTypography-root {\n  font-size: 25px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
